import Vue from 'vue'

// Axios
import axios from 'axios'
import VueAxios from 'vue-axios'
// Vue Toast
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
// i18n
import i18n from '../i18n'
import UserActivityService from "../Services/Api/UserActivityService";

Vue.use(VueToast)
axios.defaults.baseURL = process.env.VUE_APP_URL

axios.interceptors.request.use(
    (config) => {
        return config
    },
    (error) => {
        return Promise.reject(error)
    },
)

let notification = null
axios.interceptors.response.use((response) => {
    notification = response.config.url.includes('notificationOff')
    const methods = ['put', 'post', 'delete']
    const method = response.config.method.toLowerCase()
    if (methods.includes(method) && !notification) {
        switch (true) {
            case method === 'put':
                Vue.$toast.success(i18n.t('http.messages.update'), {
                    position: 'top'
                })
                break
            case method === 'post' && !notification:
                Vue.$toast.success(i18n.t('http.messages.saved'), {
                    position: 'top'
                })
                break
            case method === 'delete':
                Vue.$toast.info(i18n.t('http.messages.deleted'), {
                    position: 'top'
                })
                break
        }
    }
    return response
}, (error) => {
    if (error.response?.status === 401 && !notification) {
        localStorage.removeItem('sellerdeskai-auth')
        Vue.$toast.warning(i18n.t('http.messages.auth_error'), {
            position: 'top'
        })
    } else if (error.response?.status === 422) {
        try {
            if (error.response?.data?.errors) {
                const errors = error.response.data.errors
                for (const item in errors) {
                    errors[item].forEach(mes => {
                        Vue.$toast.warning(mes, {
                            position: 'top',
                            duration: 5000
                        })
                    })
                }
            } else if (error.response?.data?.message) {
                Vue.$toast.warning(error.response.data.message, {
                    position: 'top',
                    duration: 5000
                })
            }
        } catch (e) {
            //
        }
    } else if (error.response?.status === 500) {
        Vue.$toast.warning(i18n.t('http.messages.system_error'), {
            position: 'top'
        })

        if (!error.response.config.url.includes('user-activity'))
            UserActivityService.log('User got 500 error.', {
                url: error.response?.config?.url,
                method: error.response?.config?.method,
                time: +new Date()
            })

    } else if (error.response?.status === 404) {
        Vue.router.push({name: '404'})
    }
    return Promise.reject(error.response)
})

Vue.use(VueAxios, axios)

export default {
    root: process.env.VUE_APP_URL,
}
